var dev_mode = true;
/* console bypass */
var konsole = window.konsole = (dev_mode && console && console.log && console.dir) ? console : (function() {
  var noop = () => {},
    ret = {},
    methods = [
      'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error', 'exception', 'group',
      'groupCollapsed', 'groupEnd', 'info', 'log', 'markTimeline', 'profile', 'profileEnd',
      'markTimeline', 'table', 'time', 'timeEnd', 'timeStamp', 'trace', 'warn'
    ],
    length = methods.length;
  while (length--) {
    ret[methods[length]] = noop;
  }
  return ret;
}());


export default konsole;
